import React, {forwardRef,useEffect,useRef} from 'react'
import { useDragLayer } from 'react-dnd'
// import { ItemTypes } from './ItemTypes.js'
// import { snapToGrid } from './snapToGrid.js'
import useDragAndDropContext from '../hooks/useDragAndDropContext.js'

const DefaultPreview = forwardRef((props, ref) => {
    const {className, data = {}, style = {}} = props
    return <button {...{...props, data:undefined, dnd_id:undefined}}
        data-handler-id={props.dnd_id}
        ref={ref}
        style={{  borderRadius: '25px'}}
        className={`${className} ${style.item}`}>
            <label><span dangerouslySetInnerHTML={{__html:data.label}}></span></label>
    </button>
})
const layerStyles = {
  position: 'fixed',

  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
}
function getItemStyles(initialOffset, currentOffset) {
  //console.log(initialOffset, currentOffset)

  if (!initialOffset || !currentOffset) {
    return {
     display: 'none',
    }
  }
  let { x, y } = currentOffset
  const transform = `translate(${x}px, ${y}px)`
  return {
    transform,
    WebkitTransform: transform,
  }
}
export const CustomDragLayer = (props) => {
    const { config = {}, data, style } = props
    const { preview:Preview = DefaultPreview} = config
    const domRef = useRef()
    const { itemType, isDragging, item, initialOffset, currentOffset, monitor } =
    useDragLayer((monitor) => ({
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
      monitor:monitor
    }))

  function renderItem() {
    //console.log("DragLayer", monitor, item, itemType, isDragging, initialOffset, currentOffset, monitor.getDifferenceFromInitialOffset())

    return <Preview ref={domRef} data={item.data} style={item.style} />

    // switch (itemType) {
    //   case ItemTypes.BOX:
    //     return <Preview title={item.title} />
    //   default:
    //     return null
    // }
  }
  

  if (!isDragging) {
    return null
  }
  return (
    <div style={layerStyles}>
      <div
        style={getItemStyles(initialOffset, currentOffset)}
      >
        {renderItem()}
      </div>
    </div>
  )
}
